module.exports = function(app) {
	'use strict';
	app.service('employee', ['services', '$q', '$filter', 'planAdmin','storage', function(services, $q, $filter, planAdmin, storage) {

		this.data = null;
		this.metadata = {};

		this.default = {
			employee: require('./defaultEmployee.json'),
			dependent: require('./defaultDependent.json')
		};

		this.isLoading = false;
		this.failed = false;
		this.succeeded = false;

		this.loadSummary = function(umi) {
			return this.load(umi);
		}.bind(this);

		this.loadEnrollment = function(subscriberSSN) {
			return this.load(subscriberSSN, true);
		}.bind(this);

		this.load = function(id, inProcess) {
			this.data = this.data || {};

			var normalizeIncomingDate = function(date, defaultToToday) {
				return $filter('dateInput')(date, defaultToToday);
			};
			var normalizeIncomingDates = normalizeDates(normalizeIncomingDate);

			var setModelData = function(data) {
				this.data.globalCoverageEffectiveDate = normalizeIncomingDate(data.globalCoverageEffectiveDate);
				this.data.clientAssignedId = data.clientAssignedId;
				this.data.umi=data.umi;
				this.data.agreementNumber = data.agreementNumber;
				this.data.subscriber = normalizeIncomingDates([data.subscriber])[0];
				if('isCOBDataProcessed' in data){
                    this.data.isCOBDataProcessed = (data.isCOBDataProcessed.toUpperCase() == 'NO') ? true : false;
				}
				this.data.subscriber.hireDate = normalizeIncomingDate(data.subscriber.hireDate);
				this.data.dependents = normalizeIncomingDates(data.dependents);
			}.bind(this);

			if (!id) {
				setModelData(angular.copy(this.default.employee));
				this.succeeded = true;
				return $q.when(this);
			}

			this.failed = false;
			this.isLoading = true;

			var request;
			var serviceName;
			if (inProcess) {
				request = services.eprsvc.enrollments().fetchPathSSN(id);
				serviceName = 'enrollments';
			}
			else {
				//Code changes for PM78639
				request = services.eprsvc.employeesSummary().fetch(id);
				serviceName = 'employeeSummary';
			}

			this.ready = request.then(
				function(response) {
					this.isLoading = false;
					this.failed = false;
					this.succeeded = true;
					if (response && response.data && response.data.payload) {
						setModelData(angular.extend(angular.copy(this.default.employee), angular.copy(response.data.payload)));
						return this;
					}
					return new Error(serviceName + ' returned an unexpectedly formatted response: ' + JSON.stringify(response));
				}.bind(this),
				function() {
					this.isLoading = false;
					this.succeeded = false;
					this.failed = true;
					return this;
				}.bind(this)
			);
			return this.ready;
		}.bind(this);

		this.save = function(employee, isFinal, cleanCoverage) {
			this.failed = false;
			this.succeeded = false;
			this.isLoading = true;

			var stripAngularMetaData = function(angulstInfestedObject) {
				var clean = angular.copy(angulstInfestedObject);
				delete clean["$$hashkey"]; // jshint ignore: line
				return clean;
			};

			var scrubFilthyEmployeeData = function(employeeData) {
				var clean = stripAngularMetaData(employeeData);
				Object.keys(clean).forEach(function(k) {
					if (typeof k === "object") {
						clean[k] = scrubFilthyclean(clean[k]); // jshint ignore: line
					}
				});
				return clean;
			};

			var normalizeOutgoingDate = function(date) {
				return $filter('date')(date, 'MM/dd/yyyy');
			};
			var normalizeOutgoingDates = normalizeDates(normalizeOutgoingDate);

			var data = angular.copy(employee).data;
			data.globalCoverageEffectiveDate = normalizeOutgoingDate(data.globalCoverageEffectiveDate);
			data.subscriber = normalizeOutgoingDates([data.subscriber])[0];

			if (data.subscriber.cobra) { delete data.subscriber.cobra; }
			if(isFinal){
                storage.del('isCobra');
			}
            if (data.subscriber.contractId) { delete data.subscriber.contractId; }
			cleanMedicare([data.subscriber].concat(data.dependents));

			data.subscriber.hireDate = normalizeOutgoingDate(data.subscriber.hireDate);
			data.dependents = normalizeOutgoingDates(data.dependents);

			var service = isFinal ? services.eprsvc.employeesSummary() : services.eprsvc.enrollments();

			var originalData = scrubFilthyEmployeeData(angular.copy(this.data));
			originalData.subscriber = normalizeOutgoingDates([originalData.subscriber])[0];
			originalData.dependents = normalizeOutgoingDates(originalData.dependents);
			originalData.subscriber.hireDate = normalizeOutgoingDate(originalData.subscriber.hireDate);
			originalData.subscriber.phones = originalData.subscriber.phones || {};
			originalData.subscriber.phones.home = originalData.subscriber.phones.home || "";
			originalData.subscriber.phones.work = originalData.subscriber.phones.work || "";
			originalData.subscriber.phones.fax = originalData.subscriber.phones.fax || "";
			originalData.subscriber.phones.mobile = originalData.subscriber.phones.mobile || "";
			if (originalData.subscriber.cobra && !originalData.subscriber.cobra.value) {
				delete originalData.subscriber.cobra;
			}
			if (typeof originalData.subscriber.cobra === "boolean" && !originalData.subscriber.cobra) {
				delete originalData.subscriber.cobra;
			}
			if (!data.subscriber.hireDate) {
				data.subscriber.hireDate = "";
			}

			var coveragesToSend = {};

			var participantChanged = function(participant, subscriber) {
				var d = angular.copy(participant);
				var o;
				if (subscriber) {
					o = angular.copy(originalData.subscriber);
				}
				else {
					o = angular.copy(originalData.dependents.find(function(i) {
						i = angular.copy(i);
						var p = angular.copy(participant);
						delete p.memberCoverages;
						delete i.memberCoverages;
						return angular.equals(p, i);
					}));
				}

				if (o) {
					delete o.memberCoverages;
					delete d.memberCoverages;
				}
				return !angular.equals(o, d);
			};

			var normalizeDataForComparison = function(i) {
				i.tobaccoStatus = i.tobaccoStatus || "";
				i.tobaccoUsageDate = i.tobaccoUsageDate || "";
				if (i.reportCodes && i.reportCodes.forEach) {
					i.reportCodes.forEach(function(c) {
						delete c.cancel;
						delete c.effectiveDate;
					});
				}
			};

			var checkCoverageChangesForParticipant = function(participant, subscriber) {
				var d = angular.copy(participant);
				var o;
				if (subscriber) {
					o = angular.copy(originalData.subscriber);
				}
				else {
					o = angular.copy(originalData.dependents.find(function(i) {
						i = angular.copy(i);
						var p = angular.copy(participant);
						delete p.memberCoverages;
						delete i.memberCoverages;
						return angular.equals(p, i);
					}));
				}

				var squanch = false;
				if (d && d.memberCoverages) {
					d.memberCoverages.forEach(function(coverage, index) {
						// Look for matching coverage
						var match = null;
						if (o && o.memberCoverages) {
							match = o.memberCoverages.find(function(i) {
								return coverage.groupNumber == i.groupNumber;
							});
						}
						if (match) {
							var cancelled = false;
							var newlyAddedToPreviouslyCancelled = false;
							if (match.memberLobs) {
								cancelled = match.memberLobs.every(function(lob) {
									if (lob.coverageEndDate) {
										return lob.coverageEndDate && (new Date() > new Date(lob.coverageEndDate));
									}
								});
							}
							if (cancelled && !angular.equals(coverage.memberLobs,match.memberLobs)) { // may have added a previously canceled coverage
								newlyAddedToPreviouslyCancelled = true;
								participant.memberCoverages[index].memberLobs = coverage.memberLobs.filter(function(c) {
									return !(match.memberLobs.some(function(m) { return angular.equals(m, c); }));
								});

							}
							if (!cancelled || newlyAddedToPreviouslyCancelled) {
								normalizeDataForComparison(coverage);
								normalizeDataForComparison(match);

                                if(match.providerInformation){
                                    if(!match.providerInformation.cancelCode){
                                        match.providerInformation.cancelCode = '';
                                    }
                                    if(!match.providerInformation.physicianCancellationDate){
                                        match.providerInformation.physicianCancellationDate = '';
                                    }
                                }
								if (!angular.equals(coverage, match)) {
									coveragesToSend[coverage.groupNumber] = true;
								}

								if (!squanch) {
									// if first coverage, check to see if participant data has changed, if it has we have to send at least 1 coverage with it
									if (participantChanged(d, subscriber)) {
                                        d.memberCoverages.forEach(function(coverageT) {
                                            coveragesToSend[coverageT.groupNumber] = true;
                                        });
										squanch = true;
									}
								}
							}
						}
						else {
							// No Match, new coverage, send it
							coveragesToSend[coverage.groupNumber] = true;
						}
					});
				}
			};

			var removeCoverages = function(participant) {
				participant.memberCoverages = participant.memberCoverages.filter(function(c) {
					return coveragesToSend[c.groupNumber];
				});
			};

			if (cleanCoverage) {
				checkCoverageChangesForParticipant(data.subscriber, true);
				if (data.dependents && data.dependents.length && data.dependents.length > 0) {
					data.dependents.forEach(function(dependent) {
						checkCoverageChangesForParticipant(dependent);
					});
				}

				removeCoverages(data.subscriber);
				if (data.dependents && data.dependents.length && data.dependents.length > 0) {
					data.dependents.forEach(function(dependent) {
						removeCoverages(dependent);
					});
				}
			}

			if (cleanCoverage && Object.keys(coveragesToSend).length == 0) {
				this.isLoading = false;
				this.succeeded = true;
				return $q.reject({message: "No changes to save"});
			}
			else {
				return service.save(data, employee.data.subscriber.ssn).then(
					function(response) {
						this.isLoading = false;
						return response;
					}.bind(this),
					function(error) {
						this.isLoading = false;
						this.failed = true;
						return $q.reject(error);
					}.bind(this)
				);
			}
		}.bind(this);

		this.goThroughSubscriberAndDo = function(employeeData, action) {
			action(employeeData.subscriber);
		}.bind(this);

		this.goThroughDependentsAndDo = function(employeeData, action) {
			for (var x = 0; x < employeeData.dependents.length; x++) {
				action(employeeData.dependents[x], x);
			}
		}.bind(this);

		this.goThroughAllMembersAndDo = function(employeeData, action) {
			this.goThroughSubscriberAndDo(employeeData, action);
			this.goThroughDependentsAndDo(employeeData, action);
		}.bind(this);

		this.addDependent = function(employee) {
			employee = employee || this;
				employee.data.dependents.push(angular.copy(require('./defaultDependent.json')));
		}.bind(this);

		this.changeMedicare = function() {
		};

		this.addOtherInsurance = function(participant) {
			participant.otherInsurance = {};
		};

		this.removeOtherInsurance = function(participant) {
			delete participant.otherInsurance;
		};

		this.hasOtherInsurance = function(participant) {
			return participant.otherInsurance instanceof Object;
		};

		this.getParticipantsWithOtherInsurance = function(employeeData) {
			employeeData = employeeData || this.data;
			return [employeeData.subscriber].concat(employeeData.dependents).filter(this.hasOtherInsurance);
		}.bind(this);

		this.addMNLOA = function(participant) {
			participant.mnloa = {};
		};

		this.removeMNLOA = function(participant) {
			delete participant.mnloa;
		};

		this.hasMNLOA = function(participant) {
			return participant.MNLOA instanceof Object;
		};

		this.addMedicare = function(participant) {
			participant.medicareEligible = {};
		};

		this.removeMedicare = function(participant) {
			delete participant.medicareEligible;
		};

		this.hasMedicare = function(participant) {
			return participant.medicareEligible instanceof Object;
		};

		this.getParticipantsWithMedicare = function(employeeData) {
			employeeData = employeeData || this.data;

			return [employeeData.subscriber].concat(employeeData.dependents).filter(
				function(p) { return p.medicareEligible instanceof Object; }
			);
		}.bind(this);

		this.getDisplayName = function(participant) {
			var fullName = participant.fullName || {};
			return $filter('capitalize')([
				fullName.first,
				fullName.middle,
				fullName.last
			].filter(function(n) { return n; }).join(' '));
		};

		this.getParticipantByPIN = function(pin, employeeData) {
			employeeData = employeeData || this.data;
			return [employeeData.subscriber].concat(employeeData.dependents).filter(
				function(p) { return p.pin === pin; }
			)[0];
		}.bind(this);
        //RF1308194 method to fetch dependent using his details.
        this.getParticipantBDandGender = function(dep, employeeData) {
            employeeData = employeeData || this.data;
            return [employeeData.subscriber].concat(employeeData.dependents).filter(
                function(p) { return (p.fullName.first === dep.fullName.first && p.fullName.last === dep.fullName.last
                && p.fullName.birthDate == dep.fullName.birthDate && p.fullName.gender == dep.fullName.gender)}
                //fullName.first, last, birthDate,gender
            )[0];
        }.bind(this);
        this.checkSep = function(startDate, toDate){
            function truncateToDay(date) {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                date.setMilliseconds(0);
                return date;
            }
            // var check = new Date();
            // var from = new Date(startDate);
            // var to = new Date(toDate);
            // console.log("from",from);
            // console.log("check",check);
            // console.log("to",to);
            // return (check >= from && check <= to);

            var beforeDate = truncateToDay(new Date(startDate.replace(/-/g, '\/').replace(/T.+/, '')));
            var changeDate = truncateToDay(new Date());
            var afterDate =   truncateToDay(new Date(toDate.replace(/-/g, '\/').replace(/T.+/, '')));

            return (changeDate >= beforeDate && changeDate <= afterDate);
        }


		this.editInProgress = Object.create(this, {
			data: {
				value: null,
				writable: true
			},
			employee: {
				value: this,
				writable: true
			},
			init: {
				value: function() {
					this.data = planAdmin.extractModifiableData( angular.copy(this.employee.data) );
					return this;
				}
			},
			reset: {
				value: function() {
					console.debug('employee.editInProgress was reset');
					this.data = null;
					this.coverages = {
						forDeletion: [],
						forAddition: []
					};
				},
				writable: true
			},
			isActive: {
				value: function() { return this.data && this.data instanceof Object; }
			},
			coverages: {
				value: {
					forDeletion: [],
					forAddition: []
				},
				writable: true
			}
		});

		function normalizeDates(normalize) {
			return function(participants) {
				participants.forEach(function(p) {
					if (p.contractCovEffDte) { delete p.contractCovEffDte; } // this should never have been put on the data
					if (p.contractCovEffDteForDisplay) { delete p.contractCovEffDteForDisplay; } // this should never have been put on the data

					if (p.birthDate) { p.birthDate = normalize(p.birthDate); }
					if(p.eventDate){p.eventDate = normalize(p.eventDate);}
					if(p.optingIn){
                        delete p.optingIn;
					}
					if (p.qualifyingEventDate) { p.qualifyingEventDate = normalize(p.qualifyingEventDate); }

					if (p.otherInsurance) {
						if (p.otherInsurance.effectiveDate) { p.otherInsurance.effectiveDate = normalize(p.otherInsurance.effectiveDate); }
						if (p.otherInsurance.cancelDate) { p.otherInsurance.cancelDate = normalize(p.otherInsurance.cancelDate); }
						if (p.otherInsurance.policyHolderBirthDate) { p.otherInsurance.policyHolderBirthDate = normalize(p.otherInsurance.policyHolderBirthDate); }
						if (p.otherInsurance.retirementDate) { p.otherInsurance.retirementDate = normalize(p.otherInsurance.retirementDate); }
					}
					if (p.medicareEligible && !angular.equals(p.medicareEligible, {})) {
						if (p.medicareEligible.disStart) { p.medicareEligible.disStart = normalize(p.medicareEligible.disStart); }

						if (p.medicareEligible.ssdiDates) {
							if (p.medicareEligible.ssdiDates.startDate) { p.medicareEligible.ssdiDates.startDate = normalize(p.medicareEligible.ssdiDates.startDate); }
							if (p.medicareEligible.ssdiDates.endDate) { p.medicareEligible.ssdiDates.endDate = normalize(p.medicareEligible.ssdiDates.endDate); }
						}
						if (p.medicareEligible.partA) {
							if (p.medicareEligible.partA.startDate) { p.medicareEligible.partA.startDate = normalize(p.medicareEligible.partA.startDate); }
							if (p.medicareEligible.partA.endDate) { p.medicareEligible.partA.endDate = normalize(p.medicareEligible.partA.endDate); }
						}
						if (p.medicareEligible.partB) {
							if (p.medicareEligible.partB.startDate){ p. medicareEligible.partB.startDate = normalize(p. medicareEligible.partB.startDate ); }
							if (p.medicareEligible.partB.endDate){ p. medicareEligible.partB.endDate = normalize(p. medicareEligible.partB.endDate ); }
						}
						if (p.medicareEligible.partCInfo && p.medicareEligible.partCInfo.effectiveDate) {
							if (p.medicareEligible.partCInfo.effectiveDate.startDate){
								p.medicareEligible.partCInfo.effectiveDate.startDate = normalize(p.medicareEligible.partCInfo.effectiveDate.startDate);
							}
							if (p.medicareEligible.partCInfo.effectiveDate.endDate) {
								p.medicareEligible.partCInfo.effectiveDate.endDate = normalize(p.medicareEligible.partCInfo.effectiveDate.endDate);
							}
						}
						if (p.medicareEligible.partDInfo && p.medicareEligible.partDInfo.effectiveDate) {
							if (p.medicareEligible.partDInfo.effectiveDate.startDate) {
								p.medicareEligible.partDInfo.effectiveDate.startDate = normalize(p.medicareEligible.partDInfo.effectiveDate.startDate);
							}
							if (p.medicareEligible.partDInfo.effectiveDate.endDate) {
								p.medicareEligible.partDInfo.effectiveDate.endDate = normalize(p.medicareEligible.partDInfo.effectiveDate.endDate);
							}
						}
					}
					if (p.mnloa && !angular.equals(p.mnloa, {}) && p.mnloa.startDate) {
						p.mnloa.startDate = normalize(p.mnloa.startDate);
						p.mnloa.certify = angular.copy(p.mnloa.startDate);
					}
					if (Array.isArray(p.memberCoverages)) {
						for (var w = 0; w < p.memberCoverages.length; w++) {
							if (p.memberCoverages[w].tobaccoUsageDate) {
								p.memberCoverages[w].tobaccoUsageDate = normalize(p.memberCoverages[w].tobaccoUsageDate);
							}
							if (p.memberCoverages[w].tobaccoEffectiveBeginDate) {
								p.memberCoverages[w].tobaccoEffectiveBeginDate = normalize(p.memberCoverages[w].tobaccoEffectiveBeginDate);
							}
							if (p.memberCoverages[w].tobaccoEffectiveEndDate) {
								p.memberCoverages[w].tobaccoEffectiveEndDate = normalize(p.memberCoverages[w].tobaccoEffectiveEndDate);
							}

							if (Array.isArray(p.memberCoverages[w].memberLobs)) {
								for (var x = 0; x < p.memberCoverages[w].memberLobs.length; x++) {
									p.memberCoverages[w].memberLobs[x].coverageEffectiveDate = normalize(p.memberCoverages[w].memberLobs[x].coverageEffectiveDate);
									p.memberCoverages[w].memberLobs[x].coverageEndDate = normalize(p.memberCoverages[w].memberLobs[x].coverageEndDate);
								}
							}
							if (p.memberCoverages[w].providerInformation) {
								if (p.memberCoverages[w].providerInformation.physicianEffectiveDate) {
									p.memberCoverages[w].providerInformation.physicianEffectiveDate = normalize(p.memberCoverages[w].providerInformation.physicianEffectiveDate);
								}
								if (p.memberCoverages[w].providerInformation.physicianCancellationDate) {
									p.memberCoverages[w].providerInformation.physicianCancellationDate = normalize(p.memberCoverages[w].providerInformation.physicianCancellationDate);
								}
							}
						}
					}
				});
				return participants;
			};
		}

		function cleanMedicare(allParticipants) {
			var deleteDatelessMedicare = function(p, partLetter) {
				var part = 'part' + partLetter;

				if (
					p.medicareEligible &&
					p.medicareEligible[part] &&
					p.medicareEligible[part] instanceof Object &&
					!( p.medicareEligible[part].startDate || p.medicareEligible[part].cancelDate )
				) {
					delete p.medicareEligible[part];
				}
			};

			var deleteIneligibleMedicare = function(p, partLetter) {
				var part = 'part' + partLetter.toUpperCase();

				if (
					p.medicareEligible &&
					!( p.medicareEligible[part] || p.medicareEligible[part] === 'false' )
				) {
					delete p.medicareEligible[part + 'Info'];
				}
			};

			allParticipants.forEach(function(p) {
				if (
					p.medicareEligibleIndicator &&
					p.medicareEligibleIndicator.toLowerCase &&
					p.medicareEligibleIndicator.toLowerCase() === 'yes'
				) {
					[ 'A', 'B' ].forEach(function(l) { deleteDatelessMedicare(p, l); });
					[ 'C', 'D' ].forEach(function(l) {	deleteIneligibleMedicare(p, l); });
				}
			});
		}
	}]);
};
